import React from "react";

// inhouse icons
import { Search, X } from "@/components/icons_new";

const SimpleSearchControls = ({ searchTerm, updateSearchTerm, placeholder = "Search..." }) => {
  return (
    <div className="mb-[1em] px-[0.5em] py-[0.5em] flex flex-col gap-[1em] border bg-white rounded-t-xl">
      <div className="bg-[#F8F8F8] relative px-3 py-2 rounded-md flex flex-row items-center gap-[1em]">
        <Search className="w-5 h-5 text-[#737373]" />
        <input
          type="text"
          placeholder={placeholder}
          value={searchTerm}
          onChange={(e) => {
            const sanitized = e.target.value
              .replace(/[^a-zA-Z0-9\s\-_.@]/g, "")
              .slice(0, 100);
            updateSearchTerm(sanitized);
          }}
          className="w-full text-[#000] bg-[#F8F8F8] placeholder:text-[#8a8a8a] outline-none font-medium"
        />
        {searchTerm && (
          <button
            onClick={() => updateSearchTerm("")}
            className="absolute right-3 text-[#999] hover:text-black"
            aria-label="Clear search"
          >
            <X className="w-5 h-5 text-[#000000]" />
          </button>
        )}
      </div>
    </div>
  );
};

export default SimpleSearchControls;
